import { render } from "./Switch.vue?vue&type=template&id=29214b16&ts=true&lang=pug"
import script from "./Switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./Switch.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__